// @flow
const DELIMITER = ',';
const DECIMAL_MARK = '.';
const DECIMAL_SCALE = 2;
const NON_DECIMAL_CURRENCIES = [
  'BIF',
  'CLP',
  'DJF',
  'GNF',
  'JPY',
  'KMF',
  'KRW',
  'MGA',
  'PYG',
  'RWF',
  'UGX',
  'VND',
  'VUV',
  'XAF',
  'XOF',
  'XPF',
];

export const commaFormat = (
  price: number | string,
  currency?: string
): string => {
  if (typeof price === 'undefined') return '';
  let p: string = '';
  if (typeof price !== 'number' && typeof price !== 'string') return '';
  const isNonDecimalCurrency = currency
    ? NON_DECIMAL_CURRENCIES.includes(currency)
    : false;
  if (typeof price === 'number') {
    if (!isNonDecimalCurrency)
      p = (Math.round(price * 100) / 100).toFixed(DECIMAL_SCALE);
    else p = Math.round(price).toString();
  } else {
    if (isNaN(parseFloat(price))) p = price;
    else if (!isNonDecimalCurrency)
      p = (Math.round(parseFloat(price) * 100) / 100).toFixed(DECIMAL_SCALE);
    else p = Math.round(parseFloat(price)).toString();
  }

  let parts = '',
    partInteger = p,
    partDecimal = '';
  if (p.indexOf(DECIMAL_MARK) >= 0) {
    parts = p.split(DECIMAL_MARK);
    partInteger = parts[0];
    partDecimal = DECIMAL_MARK + parts[1].slice(0, DECIMAL_SCALE);
  }
  partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + DELIMITER);
  return `${currency ? currency + ' ' : ''}${partInteger}${partDecimal}`;
};

export function priceFormat(price: string | number, currency?: string): string {
  if (typeof price === 'undefined') return '';
  if (typeof price === 'string') price = parseFloat(price);
  if (price < 0) return `-${commaFormat(-price, currency)}`;
  if (price === 0) return 'Gratis';
  return commaFormat(price, currency);
}

export const percentageRatio = (
  numerator: number | string,
  denominator: number | string,
  precision?: number = 0
): string => {
  if (typeof numerator === 'undefined' || typeof denominator === 'undefined')
    return '';
  let num, dem: number;
  if (typeof numerator === 'string') num = parseFloat(numerator);
  else num = numerator;
  if (typeof denominator === 'string') dem = parseFloat(denominator);
  else dem = denominator;

  let ratio = ((dem - num) * 100) / dem;
  const sign = ratio < 0 ? '+' : '-';

  if (precision) ratio = ratio.toFixed(precision);
  else ratio = Math.round(ratio);

  return `${sign}${ratio} %`;
};

export function formatBits(bits: number): string {
  const units = ['bits', 'Kb', 'Mb', 'Gb'];
  let unit = 0;
  while (bits >= 1024) {
    bits /= 1024;
    unit++;
  }
  const decimal = unit === 0 ? 0 : 2;

  return `${bits.toFixed(decimal)} ${units[unit]}`;
}
